import React, { useEffect, useState, useRef } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {  faChevronDown, faPaperclip, faPlus, faPlusCircle, faTrash, faX ,faImage } from '@fortawesome/free-solid-svg-icons';
import {Loader} from '../Loader/Loader';
import { FaRegTrashAlt } from 'react-icons/fa';
import { Spinner } from '../Loader/Loader';
import { Msg200or201, Msg204, Msg400, Msg401 ,Msg403, Msg500 } from '../Messages/Messages';
import { useLocation, useNavigate } from 'react-router-dom';
import { validate } from '../CommenResponseAndErrorHandlers/commenUiErrorHandlers';
import useAutoScroll from '../Components/UseAutoScroll';
import { decryptData } from '../../utils/storageCrypto';
//import  '../Css/Tooltip.css';

const useOutsideClick = (ref, callback) => {
  const handleClick = (e) => {
    if (ref.current && !ref.current.contains(e.target)) {
      callback();
    }
  };

  React.useEffect(() => {
    document.addEventListener('click', handleClick);
    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, []);
};


const CustomDropdown = ({ options, selected, onSelect }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  useOutsideClick(dropdownRef, () => setIsOpen(false));

  const handleOptionClick = (value) => {
    onSelect(value);
    setIsOpen(false);
  };


  return (
    <div className="relative w-1/6" ref={dropdownRef}>
    <div
      className="flex justify-between items-center p-2 border bg-white border-gray-300 rounded-md cursor-pointer"
      onClick={() => setIsOpen(!isOpen)}
    >
      <span className={`text-sm ${selected ? 'text-black' : 'text-[#838195]'}`}>
        {selected || 'Salu'}
      </span>
      <FontAwesomeIcon icon={faChevronDown} className="w-3 h-3 text-gray-500" />
    </div>
    {isOpen && (
      <div className="absolute mt-1 w-full h-40 bg-white border border-gray-300 rounded-md shadow-lg z-10 flex flex-col">
        <div className="overflow-y-auto scrollbar-visible flex-grow">
          {options.map((option) => (
            option.value !== 'add-new' && (
              <div className='p-1'>

              <div

                key={option.value}

                className="py-2 pl-1 cursor-pointer text-sm hover:bg-blue-500 hover:rounded-md  hover:text-white"

                onClick={() => handleOptionClick(option.value)}

              >

                {option.icon && <FontAwesomeIcon icon={option.icon} className="" />}

                {option.label}

              </div>

              </div>

            )

          ))}

        </div>

      </div>

    )}

  </div>

  

  );

};

const ViewProductGroup = () => {
    const navigate= useNavigate();
    const [productCategories, setProductCategories] = useState([
      ]);
      const [productGroups, setProductGroups] = useState([
      ]);
      const [productAttributes, setProductAttributes] = useState([
      ]);
      
      const [productSubcategories, setProductSubcategories] = useState([
      ]);
   const location= useLocation();
   const {ItemGroupData} = location.state || {}
  const [selectedProductCategory, setSelectedProductcategory] = useState(null);
  const [selectedProductGroup, setSelectedProductGroup] = useState(null);
  const [productGroupid , setproductGroupid] = useState(null);
  const [showProjectDetailsPopup, setShowProjectDetailsPopup] = useState(false);
  const backendApiUrl = process.env.REACT_APP_FORE_BRICKBUCKET;
  const url = process.env.REACT_APP_FORE_BRICKBUCKET
  const [isLoading, setIsLoading] = useState(true);
  const imageUrl = process.env.REACT_APP_FORE_BRICKBUCKET_IMAGES
  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState('');
  const [popupType, setPopupType] = useState('');
  const [errorMessages, setErrorMessages] = useState([]);
  const [vendor , setvendor] = useState()
  const [productCategory , setProductCategory] = useState()
  const [attributes , setAttributes] = useState([])
  const [showAssignAttributesPopup, sethowAssignAttributesPopup] = useState(false)
  const [attributeLoading , setAttributesloading]= useState(true)
  const [attributeIds, setAttributeIds] = useState([]);
  const [isSaving, setIsSaving] = useState(false);
  const [ProductGroupLoader,setProductGroupLoader]= useState(true);
  const [errors, setErrors] = useState({});
  const RETRY_LIMIT = 3; // Maximum number of retries
  const [retryCount, setRetryCount] = useState(0); // Track retry attempts
  const [retryFunction, setRetryFunction] = useState(null);
  const [imageSrc, setImageSrc] = useState('');
  const [isUploading, setIsUploading] = useState(false);
  const [roleId, setRoleId] = useState(null);
  const [assignType, setAssignType] = useState('');
  const [AddOnsProductGroups,setAddOnsProductGroups] = useState([]);
  //const [addOnGroupIds , setAddOnGroupIds] = useState([]);
  const [selectedAddOns, setSelectedAddOns] = useState([]);
  const [showQuantityPricingPopup, setShowQuantityPricingPopup] = useState(false);
  const [quantityPricingRows, setQuantityPricingRows] = useState([
    { minQuantity: '', maxQuantity: '', sellingPrice: '', costPrice: '' }
  ]);
  const [productMoqsData, setProductMoqsData] = useState({});

  const itemRefs = useRef({});
  const listContainerRef = useRef(null);
  const assignDropdownRef = useRef(null);

/*   useEffect(() => {
    const fetchProductCategories = async () => {
        try {
            const token = sessionStorage.getItem('token');
            const response = await fetch(url + "product-category/get-all-productCategories", {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'x-token':token
                }
            });
            const data = await response.json();
            if (response.ok) {
                setProductCategories(data); // Update customers state
                console.log(data)
            } else {
                console.error(data.message);
            }
        } catch (error) {
            console.error(error);
        }
    }
    fetchProductCategories();
}, []); */

/* useEffect(() => {
    const fetchItemGroups = async () => {
        try {
            const token = sessionStorage.getItem('token');
            const response = await fetch(process.env.REACT_APP_FORE_BRICKBUCKET + "product-groups/get-all-productGroups", {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'x-token':token
                }
            });
            const data = await response.json();
            if (response.ok) {
                setProductGroups(data); // Update ItemGroups state
                console.log(data)
            } else {
                console.error(data.message);
            }
        } catch (error) {
            console.error(error);
        }finally {
          setIsLoading(false);
        }
    }
    fetchItemGroups();
}, []); */

useEffect(() => {
  fetchRoleId();
  fetchItemGroups(ItemGroupData);
}, [ItemGroupData]);

const fetchRoleId = () => {
  const encryptedroleId = sessionStorage.getItem('roleId');
  const sroleId = decryptData(encryptedroleId);
  setRoleId(sroleId);
};

useAutoScroll({
  selectedItem: selectedProductGroup,
  itemRefs,
  containerRef: listContainerRef,
});


useEffect(() => {
  function handleClickOutside(event) {
    if (
      assignDropdownRef.current &&
      !assignDropdownRef.current.contains(event.target) &&
      !showAssignAttributesPopup // ✅ important condition
    ) {
      setAssignType(null);
    }
  }

  if (assignType && !showAssignAttributesPopup) {
    document.addEventListener("mousedown", handleClickOutside);
  }

  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, [assignType, showAssignAttributesPopup]);


const fetchItemGroups = async (selecteditemGroup,attempt = 1) => {
  try {
        const encryptedToken = sessionStorage.getItem('token');
            const token = decryptData(encryptedToken);
            const encryptedHubId = sessionStorage.getItem('hubId');
            const hubId = decryptData(encryptedHubId);
    const response = await fetch(process.env.REACT_APP_FORE_BRICKBUCKET + `product-groups/get-all-productGroups?hubId=${hubId}`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'x-token': token
      }
    });
    const data = await response.json();
    if (data.status === 200 || data.status === 201 || data.status === 204) {
      setProductGroups(data.data);
      /* console.log(data.data); */
      
      // const findLatestItemGroup = data.data.find(p => 
      //   p && p._id && selecteditemGroup && selecteditemGroup._id 
      //   ? p._id === selecteditemGroup._id 
      //   : false
      // );
  
      // if (findLatestItemGroup) {
      //   setSelectedProductGroup(findLatestItemGroup);
      //   handleProductGroupClick(findLatestItemGroup);
      // } else {   
      // setSelectedProductGroup(selecteditemGroup)
      // handleProductGroupClick(selecteditemGroup)
      // }
      if (selecteditemGroup?._id) {
        const matchingGroup = data.data.find(group => group._id === selecteditemGroup._id);
        if (matchingGroup) {
          console.log('✅ Found exact match:', matchingGroup.product_group_name);
          setSelectedProductGroup(matchingGroup);
          handleProductGroupClick(matchingGroup);
          return; // 👈 Exit early
        }
      }
      

    } else if (data.status === 400) {
      setShowPopup(true);
      setPopupType('400');
      setPopupMessage('Bad Request!');
    } else if (data.status === 401) {
      setShowPopup(true);
      setPopupType('401');
      setPopupMessage('Unauthorized!');
    } else if (data.status === 403) {
      setShowPopup(true);
      setPopupType('403');
      setPopupMessage('Forbidden!');
    } else if (data.status === 404) {
      setShowPopup(true);
      setPopupType('404');
      setPopupMessage('Not Found!');
    } else if (data.status === 500) {
      setShowPopup(true);
      setPopupType('500');
      setPopupMessage('Internal Server Error!');
    } else {
      setShowPopup(true);
      setPopupType('unknown');
      setPopupMessage('Unknown error!');
    }
  } catch (error) {
    console.error('Failed to fetch:', error);

    if (attempt < RETRY_LIMIT) {
      setRetryCount(attempt + 1); // Increment retry count
      setTimeout(() => fetchItemGroups(selecteditemGroup,attempt + 1), 1000); // Retry after 1 second
    } else {
      setIsLoading(false);
      setPopupMessage('Internal Server Error. Kindly Retry.');
      setPopupType('500');
      setShowPopup(true);
      setRetryFunction(() => () => fetchItemGroups(selecteditemGroup,attempt)); // Set retry function
    }
  } finally {
    setIsLoading(false);
  }
};



  const handleProductGroupClick = (productGroup) => {
    setImageSrc(imageUrl + productGroup?.product_group_image);
    setproductGroupid(productGroup?._id);

    setSelectedProductGroup(productGroup);
    getProductGroupDetails(productGroup?._id)
    setProductGroupLoader(true);
  };

  const getProductGroupDetails = async (id,attempt = 1) => {
    try {
          const encryptedToken = sessionStorage.getItem('token');
              const token = decryptData(encryptedToken);
              const encryptedHubId = sessionStorage.getItem('hubId');
              const hubId = decryptData(encryptedHubId);
      const apiEndpoint = backendApiUrl + `product-groups/get-productGroup?id=${id}`; // Replace with your actual API endpoint
  
      // Make a GET request to the API
      const response = await fetch(apiEndpoint, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
           'x-token' : token
        },
      });

      const data = await response.json();
      console.log('Product Group Details Response:', data);
    const output =  await getResponseHandling(response , data)
    if(output){
    setAttributes(output.attributeData);
   
    setvendor(output.vendor)
    setProductCategory(output.productCategory)
    }else{
      setAttributes([])
      setvendor()
      setProductCategory()
    }
    }  catch (error) {
      console.error('Failed to fetch:', error);

      if (attempt < RETRY_LIMIT) {
        setRetryCount(attempt + 1); // Increment retry count
        setTimeout(() => getProductGroupDetails(id,attempt + 1), 1000); // Retry after 1 second
      } else {
        setIsLoading(false);
        setPopupMessage('Internal Server Error. Kindly Retry.');
        setPopupType('500');
        setShowPopup(true);
        setRetryFunction(() => () => getProductGroupDetails(id,attempt)); // Set retry function
      }
    }finally{
      setProductGroupLoader(false)
    }
  };

  const Retry = async() => {
    console.log("Retry called");
    setTimeout(async ()=>{
      if(retryFunction){
  
        await retryFunction ();
      }
  
      setIsLoading(false)
    },1000)
    
    setShowPopup(false);
  };

  const getResponseHandling = async (response, data)=>{
    if (response.ok) {
      if (response.status === 200 || response.status === 201) {
        //setPopupType('200or201');
          return (data.data)
      } else if (response.status === 204) {
       // setPopupType('204');
        return (data.data)
      } 
    } else {
      if (response.status === 400) {
        setPopupType('400');
        setPopupMessage(data.message);
        setShowPopup(true);
        return null
      } else if (response.status === 401) {
        setPopupType('401');
        setPopupMessage(data.message);
        setShowPopup(true);
        return null
      } else if (response.status === 403) {
       
        setPopupType('403');
        setPopupMessage(data.message);
        setShowPopup(true);
        return null
      } else if (response.status === 500) {
       
        setPopupType('500');
        setPopupMessage(data.message);
        setShowPopup(true);
        return null
      } else {
        setErrorMessages([...errorMessages, data.message]);
      }
    }
  }
  const handleClose = () => {
    navigate(-1);
  }
   const handleCloseAttributePopup = ()=>{
    sethowAssignAttributesPopup(false)
     setAssignType(null);
    setSelectedAddOns([])
   }

  
  
  const fetchItemCategoryAttributes = async (category, attempt = 1) => {
  setErrors({});
  
  const existingData = attributes?.map?.((attribute) => ({
    attribute_name_id: attribute.attribute_id,
    attribute_value_id: attribute.attribute_value_id,
  })) || [];
  setAttributeIds(existingData);
  
  const id = selectedProductGroup._id;
  try {
    const encryptedToken = sessionStorage.getItem('token');
    const token = decryptData(encryptedToken);
    const encryptedHubId = sessionStorage.getItem('hubId');
    const hubId = decryptData(encryptedHubId);
    
    const response = await fetch(
      `${process.env.REACT_APP_FORE_BRICKBUCKET}product-attributes/get-attr-upward?product_group_id=${id}`, 
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token
        }
      }
    );
    
    const apiData = await response.json();  // 🔥 Rename to avoid conflict
    console.log('🔥 API Response:', apiData);
    
    if (apiData.status === 200 || apiData.status === 201 || apiData.status === 204) {
      let newAttributes = apiData.data || [];  // 🔥 NEW API DATA!
      
      // 🔥 STABLE SORTING (A→Z)
      newAttributes.sort((a, b) => a.attribute_name.localeCompare(b.attribute_name));
      
      // 🔥 Sort values within each attribute consistently
      newAttributes.forEach(attr => {
        if (attr?.attribute_values) {
          attr.attribute_values.sort((a, b) => 
            a.attribute_value.localeCompare(b.attribute_value)
          );
        }
      });
      
      console.log("✅ STABLE ATTRIBUTES:", newAttributes);
      setProductAttributes(newAttributes);  // ✅ SET NEW SORTED DATA!
      
    } else if (apiData.status === 400) {
      setShowPopup(true);
      setPopupType('400');
      setPopupMessage('Bad Request!');
      setProductAttributes([]);
    } else if (apiData.status === 401) {
      setShowPopup(true);
      setPopupType('401');
      setPopupMessage('Unauthorized!');
      setProductAttributes([]);
    } else if (apiData.status === 403) {
      setShowPopup(true);
      setPopupType('403');
      setPopupMessage('Forbidden!');
      setProductAttributes([]);
    } else if (apiData.status === 404) {
      setShowPopup(true);
      setPopupType('404');
      setPopupMessage('Not Found!');
      setProductAttributes([]);
    } else if (apiData.status === 500) {
      setShowPopup(true);
      setPopupType('500');
      setPopupMessage('Internal Server Error!');
      setProductAttributes([]);
    } else {
      setShowPopup(true);
      setPopupType('unknown');
      setPopupMessage('Unknown error!');
      setProductAttributes([]);
    }
  } catch (error) {
    console.error('Failed to fetch attributes:', error);
    setProductAttributes([]);

    if (attempt < RETRY_LIMIT) {
      setRetryCount(attempt + 1);
      setTimeout(() => fetchItemCategoryAttributes(category, attempt + 1), 1000);
    } else {
      setIsLoading(false);
      setPopupMessage('Internal Server Error. Kindly Retry.');
      setPopupType('500');
      setShowPopup(true);
      setRetryFunction(() => () => fetchItemCategoryAttributes(category, attempt));
    }
  } finally {
    setAttributesloading(false);
  }
};

  // const handleRadioChange = (attribute_name_id, attributeValueId) => {
  //   const findIndexOfAttributeId = attributeIds.findIndex(
  //     (p) => p.attribute_name_id === attribute_name_id
  //   );
  
  //   if (findIndexOfAttributeId === -1) {
  //     setAttributeIds([
  //       ...attributeIds,
  //       { attribute_name_id: attribute_name_id, attribute_value_id: attributeValueId },
  //     ]);
  //   } else {
  //     if (attributeIds[findIndexOfAttributeId].attribute_value_id === attributeValueId) {
  //       const updatedAttributeIds = attributeIds.filter(
  //         (_, index) => index !== findIndexOfAttributeId
  //       );
  //       setAttributeIds(updatedAttributeIds);
  //     } else {
  //       const updatedAttributeIds = [...attributeIds];
  //       updatedAttributeIds[findIndexOfAttributeId].attribute_value_id = attributeValueId;
  //       setAttributeIds(updatedAttributeIds);
  //     }
  //   }
  // };

  const handleCheckboxChange = (attribute_name_id, attributeValueId) => {

  const findIndexOfAttributeId = attributeIds.findIndex(
    (p) =>
      p.attribute_name_id === attribute_name_id &&
      p.attribute_value_id === attributeValueId
  );

  if (findIndexOfAttributeId === -1) {
    // add new checkbox selection
    setAttributeIds([
      ...attributeIds,
      {
        attribute_name_id: attribute_name_id,
        attribute_value_id: attributeValueId,
      },
    ]);
  } else {
    // remove checkbox selection
    const updatedAttributeIds = attributeIds.filter(
      (_, index) => index !== findIndexOfAttributeId
    );

    setAttributeIds(updatedAttributeIds);
  }
};


  const handleAddattributesToGroup = async (attempt =1)=>{
    
    const attributeValueIds = attributeIds.map(item => item.attribute_value_id);
    const isattributeValueIds= attributeValueIds.length > 0
    console.log(isattributeValueIds)
    const fields = [ 
      { name: 'assign_attribute', value: isattributeValueIds, required: true,  message: 'select attribute values ', usage: 'attribute values'},  
    ];
    const validationErrors = validate(fields);
    setErrors(validationErrors);

    // Proceed only if there are no validation errors
    if (Object.keys(validationErrors).length === 0) {
    const data = {
      product_group_id: selectedProductGroup._id,
      attribute_value_ids:attributeValueIds
    }
    console.log(attributeValueIds)
        const encryptedToken = sessionStorage.getItem('token');
            const token = decryptData(encryptedToken);
            const encryptedHubId = sessionStorage.getItem('hubId');
            const hubId = decryptData(encryptedHubId);
    const url = process.env.REACT_APP_FORE_BRICKBUCKET + "product-groups/assign-attributes-to-productGroup";
    setIsSaving(true);
    try {
      const response = await fetch(url, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token
        },
        body: JSON.stringify(data)
      });
  
      const responseData = await response.json();
      if (responseData.status === 200 || responseData.status === 201) {
       
        sethowAssignAttributesPopup(false);
         setAssignType(false); 
        setIsSaving(false);
        // Display a new popup with a 5-second timer and response message
        setShowPopup(true);
        setPopupType('200or201');
        setPopupMessage("Attribute values assigned to product group successfully.");
        handleProductGroupClick(selectedProductGroup)
        setTimeout(() => {
          setShowPopup(false);
        }, 3000);
      } else if (responseData.status === 403) {
        console.error('Forbidden: Access denied');
        sethowAssignAttributesPopup(false);
        setIsSaving(false);
        setShowPopup(true);
        setPopupType('403');
        setPopupMessage('Your session has expired');
        // Log the user out and redirect to login page
      } else if (responseData.status === 404) {
        console.error('Not Found: The requested Item Group was not found');
        sethowAssignAttributesPopup(false);
        setIsSaving(false);
        setShowPopup(true);
        setPopupType('404');
        setPopupMessage('Not Found: The requested Item Group was not found. Please try updating a different Item Group or contact our support team.');
        // Allow the user to try updating a different vendor or contact support
      } else if (responseData.status === 500) {
        console.error('Internal Server Error: Please try again later');
        sethowAssignAttributesPopup(false);
        setIsSaving(false);
        setShowPopup(true);
        setPopupType('500');
        setPopupMessage('Internal Server Error: Please try again later. If the issue persists, contact our support team.');
        // Do not close the vendor details popup, allow the user to retry
      } else {
        console.error('Unknown error occurred');
        setShowPopup(true);
        setPopupType('400');
        setPopupMessage('Unknown error occurred');
      }
    } catch (error) {
      console.error('Failed to fetch:', error);

      if (attempt < RETRY_LIMIT) {
        setRetryCount(attempt + 1); // Increment retry count
        setTimeout(() => handleAddattributesToGroup(attempt + 1), 1000); // Retry after 1 second
      } else {
        setIsLoading(false);
        setPopupMessage('Internal Server Error. Kindly Retry.');
        setPopupType('500');
        setShowPopup(true);
        setRetryFunction(() => () => handleAddattributesToGroup(attempt)); // Set retry function
      }
    }
  }
  }

    // Add this function to handle input changes in the quantity pricing table
    const handleQuantityPricingChange = (index, field, value) => {
      const updatedRows = [...quantityPricingRows];
      updatedRows[index][field] = value;
      setQuantityPricingRows(updatedRows);
    };
    
    // Add this function to add a new row to the quantity pricing table
    const addQuantityPricingRow = () => {
      setQuantityPricingRows([
        ...quantityPricingRows, 
        { minQuantity: '', maxQuantity: '', sellingPrice: '', costPrice: '' }
      ]);
    };
    
    // Add this function to delete a row from the quantity pricing table
    const deleteQuantityPricingRow = (index) => {
      const updatedRows = [...quantityPricingRows];
      updatedRows.splice(index, 1);
      setQuantityPricingRows(updatedRows);
    };

  const saveQuantityPricing = async () => {
    //console.log(quantityPricingRows)
    try {
      const InputData = {
        product_category_id: selectedProductGroup?.product_category_id?._id || null,
        product_sub_category_id: selectedProductGroup?.product_sub_category_id?._id || null,
        product_group_id: selectedProductGroup?._id || null,
        moq_for_item_type : 'Product Group',
        moqs: quantityPricingRows.map(row => ({
          min_quantity: Number(row.minQuantity) || 0,
          max_quantity: Number(row.maxQuantity) || 0,
          selling_price: Number(row.sellingPrice) || 0,
          cost_price: Number(row.costPrice) || 0
        }))
      };
      console.log('InputData', InputData)
          const encryptedToken = sessionStorage.getItem('token');
              const token = decryptData(encryptedToken);
              const encryptedHubId = sessionStorage.getItem('hubId');
              const hubId = decryptData(encryptedHubId);
      console.log('token', token)
      const response = await fetch(backendApiUrl + 'moqs/create-update-moq', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token
        },
        body: JSON.stringify(InputData)
      });
      console.log(response)
      const data = await response.json();
      
      if (response.ok) {
        setShowPopup(true);
        setPopupType('200or201');
        setPopupMessage('MOQs saved successfully');
        setTimeout(() => {
          setPopupType(false)
          setPopupMessage('');
        }, 2000);
        setShowQuantityPricingPopup(false);
      } else {
        setShowPopup(true);
        setPopupType('400');
        setPopupMessage(data.message || 'Failed to save MOQs');
      }
    } catch (error) {
      console.error('Error saving MOQs:', error);
      setShowPopup(true);
      setPopupType('500');
      setPopupMessage('Internal Server Error. Please try again.');
    }
  };
  
  const closePopup = () => {
    setShowPopup(false);
  };

  const BackToLoginPage = () => {
    console.log("Back To Login Page");
    setShowPopup(false);
    localStorage.removeItem('LoginData');
    sessionStorage.removeItem('userData');
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('userId');
    sessionStorage.removeItem('appId');
  navigate('/bb');
  };

  const handleFileInputClick = () => {
    document.getElementById('imageInput').click();
  };
  
 /*  const handleImageChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append('image', file); // This should match the field name in Multer's configuration
      formData.append('_id', selectedProductGroup._id);
  
      setIsUploading(true);
  
      try {
        const token = sessionStorage.getItem('token');
        const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}product-groups/change-product-group-image`, {
          method: 'PUT',
          headers: {
            'x-token': token,
          },
          body: formData,
        });
  
        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }
  
        const data = await response.json();
  
        if (data.status === 200) {
  
          console.log(imageUrl + data.data.product_group_image);
          setImageSrc(imageUrl + data.data.product_group_image); // Update the image URL with the new uploaded image URL
          fetchItemGroups(data.data)
        } else {
          console.error('Failed to upload image:', data.message || 'Unknown error');
        }
      } catch (error) {
        console.error('Error uploading image:', error);
      } finally {
        setIsUploading(false);
      }
    }
  }; */

const handleImageChange = async (event) => {
  const file = event.target.files[0];
  if (file) {
    const formData = new FormData();
    formData.append('image', file); // This should match the field name in Multer's configuration
    formData.append('_id', selectedProductGroup._id);

    setIsUploading(true);

    try {
          const encryptedToken = sessionStorage.getItem('token');
              const token = decryptData(encryptedToken);
              const encryptedHubId = sessionStorage.getItem('hubId');
              const hubId = decryptData(encryptedHubId);
      const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}product-groups/change-product-group-image`, {
        method: 'PUT',
        headers: {
          'x-token': token,
        },
        body: formData,
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();

      if (data.status === 200) {

        console.log(imageUrl + data.data.product_group_image);
        setImageSrc(imageUrl + data.data.product_group_image); // Update the image URL with the new uploaded image URL
        fetchItemGroups(data.data)
      } else {
        console.error('Failed to upload image:', data.message || 'Unknown error');
      }
    } catch (error) {
      console.error('Error uploading image:', error);
    } finally {
      setIsUploading(false);
    }
  }
};

const handleDragOver = (e) => {
  e.preventDefault();
  e.stopPropagation();
  // Optional: Add visual feedback for drag over
  e.currentTarget.classList.add('border-blue-500', 'bg-blue-50');
};

const handleDragLeave = (e) => {
  e.preventDefault();
  e.stopPropagation();
  // Remove visual feedback
  e.currentTarget.classList.remove('border-blue-500', 'bg-blue-50');
};

const handleDrop = async (e) => {
  e.preventDefault();
  e.stopPropagation();
  
  // Remove visual feedback
  e.currentTarget.classList.remove('border-blue-500', 'bg-blue-50');
  
  const files = e.dataTransfer.files;
  if (files.length > 0) {
    const file = files[0];
    
    // Check if it's an image file
    if (file.type.startsWith('image/')) {
      const formData = new FormData();
      formData.append('image', file);
      formData.append('_id', selectedProductGroup._id);

      setIsUploading(true);

      try {
           const encryptedToken = sessionStorage.getItem('token');
               const token = decryptData(encryptedToken);
               const encryptedHubId = sessionStorage.getItem('hubId');
               const hubId = decryptData(encryptedHubId);
        const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}product-groups/change-product-group-image`, {
          method: 'PUT',
          headers: {
            'x-token': token,
          },
          body: formData,
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();

        if (data.status === 200) {
          console.log(imageUrl + data.data.product_group_image);
          setImageSrc(imageUrl + data.data.product_group_image);
          fetchItemGroups(data.data);
        } else {
          console.error('Failed to upload image:', data.message || 'Unknown error');
        }
      } catch (error) {
        console.error('Error uploading image:', error);
      } finally {
        setIsUploading(false);
      }
    } else {
      // Optional: Show error message for non-image files
      alert('Please select an image file');
    }
  }
};


  const handleNavigateEditItemGroup = () =>{
    navigate("/bb/app/items/edititemgroup", {state:{ItemGroupData:selectedProductGroup}})
    console.log(selectedProductGroup);
   }

   const handleCreateItemGroup = () => {
    navigate('/bb/app/items/newproductgroups')
  }
 
  const groupsToDisplay = roleId === 6 
  ? productGroups.filter(group => (group.product_category_id?.product_category_name.toLowerCase()) === 'tiles')
  : productGroups;
 // console.log(groupsToDisplay);


  const handleAssignTypeSelect = (type) => {
    setAssignType(type);
    if (type === 'attributes') {
      fetchItemCategoryAttributes(selectedProductGroup?.product_category_id);
    } else if (type === 'addons') {
      // Implement function to fetch add-ons
       fetchAddOnsProductGroups(selectedProductGroup?.product_category_id._id);
       fetchselecetdAddOnProductGroup(selectedProductGroup?._id);
    }
    sethowAssignAttributesPopup(true);
    //setAssignType(false); // Close the dropdown after selection

  };

  const fetchselecetdAddOnProductGroup = async (productGroupId, attempt = 0) => {
    try {
          const encryptedToken = sessionStorage.getItem('token');
              const token = decryptData(encryptedToken);
              const encryptedHubId = sessionStorage.getItem('hubId');
              const hubId = decryptData(encryptedHubId);
      const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}product-groups/get-assigned-product-group-add-ons?product_group_id=${productGroupId}`, {
        method: 'GET',
        headers: {
          'x-token': token,
        },
      });
      const data = await response.json();
      const output =  await getResponseHandling(response , data)
    
        if(output){
          setSelectedAddOns(output.add_on_product_group_ids)
          }else{
            setSelectedAddOns([])
          }
    }catch (error) {
      console.error('Failed to fetch:', error);
      if (attempt < RETRY_LIMIT) {
        setRetryCount(attempt + 1); // Increment retry count
        setTimeout(() => fetchselecetdAddOnProductGroup(attempt + 1), 1000); // Retry after 1 second
      } else {
        setIsLoading(false);
        setPopupMessage('Internal Server Error. Kindly Retry.');
        setPopupType('500');
        setShowPopup(true);
        setRetryFunction(() => () => fetchselecetdAddOnProductGroup(attempt)); // Set retry function
      }
    }
  }

  const handleOpenAssign = () => {
    setAssignType(prevState => prevState ? '' : 'attributes');
  }


  const fetchAddOnsProductGroups = async (PCid , attempt = 1) => {
    //console.log('Fetching add-ons for product group:', PCid);
    try {
          const encryptedToken = sessionStorage.getItem('token');
              const token = decryptData(encryptedToken);
              const encryptedhubId = sessionStorage.getItem('hubId');
              const hubId = decryptData(encryptedhubId);
      const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}product-groups/get-all-category-add-on-product-groups?product_category_id=${PCid}`, {
        method: 'GET',
        headers: {
          'x-token': token,
        },
      });

      const data = await response.json();
      const output =  await getResponseHandling(response , data)
    
        if(output){
         // console.log(output);
          setAddOnsProductGroups(output);
      
          }else{
            setAddOnsProductGroups([])
          }
          }  catch (error) {
            console.error('Failed to fetch:', error);
      
            if (attempt < RETRY_LIMIT) {
              setRetryCount(attempt + 1); // Increment retry count
              setTimeout(() => fetchAddOnsProductGroups(PCid, attempt + 1), 1000); // Retry after 1 second
            } else {
              setIsLoading(false);
              setPopupMessage('Internal Server Error. Kindly Retry.');
              setPopupType('500');
              setShowPopup(true);
              setRetryFunction(() => () => fetchAddOnsProductGroups(PCid,attempt)); // Set retry function
            }
          }finally{
            setProductGroupLoader(false)
            setIsLoading(false);
            setAttributesloading(false);
          }
  };


  const handleAddOnChange = (groupId) => {
    setSelectedAddOns(prevSelected => {
      if (prevSelected.includes(groupId)) {
        return prevSelected.filter(id => id !== groupId);
      } else {
        return [...prevSelected, groupId];
      }
    });
  };
 
  const handleAssignAddOnGroupsToMainGroups = async () => {
        const encryptedToken = sessionStorage.getItem('token');
            const token = decryptData(encryptedToken);
            const encryptedhubId = sessionStorage.getItem('hubId');
            const hubId = decryptData(encryptedhubId);
    setIsSaving(true);
  
    try {
      const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}product-groups/assign-add-on-product-groups`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-token': token
        },
        body: JSON.stringify({
          product_category_id: selectedProductGroup.product_category_id._id,
          main_product_group_id: selectedProductGroup._id,
          add_on_product_group_ids: selectedAddOns
        })
      });
  
      const data = await response.json();
      
      if (data.status === 200 || data.status === 201) {
        setShowPopup(true);
        setPopupType('200or201');
        setPopupMessage('Add-ons assigned successfully');
        handleProductGroupClick(selectedProductGroup);
        handleCloseAttributePopup();
        
        setTimeout(() => {
          setShowPopup(false);
        }, 2000); // Close the popup after 3 seconds
      } else {
        setShowPopup(true);
        setPopupType('400');
        setPopupMessage(data.message || 'Failed to assign add-ons');
        
        setTimeout(() => {
          setShowPopup(false);
        }, 2000); // Close the popup after 3 seconds
      }
      
    } catch (error) {
      console.error('Error assigning add-ons:', error);
      setShowPopup(true);
      setPopupType('500');
      setPopupMessage('Internal Server Error');
    } finally {
      setIsSaving(false);
    }
  };

  const handleDeleteItemGroupImage = async (selectedItemGroup) => {
       const encryptedToken = sessionStorage.getItem('token');
           const token = decryptData(encryptedToken);
           const encryptedhubId = sessionStorage.getItem('hubId');
           const hubId = decryptData(encryptedhubId);
  
    // Validate if necessary data is available
    if (!token) {
      console.error("Missing token or hubId. Unable to proceed.");
      return;
    }
  
    try {
      // Construct the API URL with query parameters
      const url = new URL(`${process.env.REACT_APP_FORE_BRICKBUCKET}product-groups/delete-product-group-image`);
  
      const itemGroupdata = {
        _id: selectedItemGroup._id,
        product_group_image: ''
      };
  
      // Make the API call
      const response = await fetch(url.toString(), {
        method: "PUT",
        headers: {
          'Content-Type': 'application/json',
          "x-token": token,
        },
        body: JSON.stringify(itemGroupdata)
      });
  
      // Check response status before parsing
      if (!response.ok) {
        const errorText = await response.text();
        console.error("Server error:", errorText);
        throw new Error(`HTTP error! status: ${response.status}`);
      }
  
      // Parse the response
      const data = await response.json();
  
      // Check if the status is successful
      if (data.status === 200) {
        console.log("Image deleted successfully.");
        handleUpdateTheImageDataInItemGroup(selectedItemGroup);
      } else {
        console.error("Failed to delete image:", data.message || "Unknown error.");
      }
    } catch (error) {
      // Catch any network or unexpected errors
      console.error("Error while deleting image:", error.message);
    }
  };
  
  
  const handleUpdateTheImageDataInItemGroup = (selectedItemGroup) => {
    try {
      // Validate input
      if (!selectedItemGroup || !selectedItemGroup._id) {
        console.error('Invalid item: Missing _id');
        return;
      }
  
      // Create a new item object with updated image
      const updatedItemGroup = {
        ...selectedItemGroup,
        product_group_image: ""
      };
  
      // Update the selected product state
      setSelectedProductGroup((prevProductGroup) => {
        // Ensure we're updating the correct product
        if (prevProductGroup?._id !== selectedItemGroup._id) {
          console.warn('Attempted to update a different product');
          return prevProductGroup;
        }
        
        return {
          ...prevProductGroup,
          product_image: ""
        };
      });
  
      // Fetch items with error handling
      const fetchItemsWithErrorHandling = async () => {
        try {
          await fetchItemGroups(updatedItemGroup);
        } catch (fetchError) {
          console.error('Error fetching items after image deletion:', fetchError);
          // Optional: Show user-friendly error notification
          // setErrorMessage('Failed to update item. Please try again.');
        }
      };
  
      // Call the fetch function
      fetchItemsWithErrorHandling();
  
      console.log(`Image data updated for item ID: ${selectedItemGroup._id}`);
    } catch (error) {
      console.error('Comprehensive error in handleUpdateTheImageDataInItem:', {
        message: error.message,
        stack: error.stack,
        item: selectedItemGroup
      });
  
      // Optional: Implement error tracking or reporting
      // errorTrackingService.report(error);
    }
  };

  const HandleMoqs = async () =>{
   await getMOQsByProductGroupId(selectedProductGroup._id)
   setShowQuantityPricingPopup(true)
  }

  const getMOQsByProductGroupId = async (productGroupId) => {
    try {
          const encryptedToken = sessionStorage.getItem('token');
              const token = decryptData(encryptedToken);
              const encryptedhubId = sessionStorage.getItem('hubId');
              const hubId = decryptData(encryptedhubId);
      const response = await fetch(`${process.env.REACT_APP_FORE_BRICKBUCKET}moqs/get-moq-by-product-group-id?product_group_id=${productGroupId}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-token": token,
        },
      });
      const data = await response.json();
      console.log(data)
      if (data.status === 200) {
        setProductMoqsData(data.data);
        const MoqsData = data.data;
        const MoqsDataArray = Array.isArray(MoqsData.moqs) ? MoqsData.moqs.map(item => ({
          minQuantity : item.min_quantity,
          maxQuantity : item.max_quantity,
          sellingPrice: item.selling_price,
          costPrice: item.cost_price
        })) : [];
        console.log(MoqsDataArray)
        setQuantityPricingRows(MoqsDataArray || []);
      } else {
        setQuantityPricingRows([])
        console.error("Failed to fetch MOQs:", data.message);
      }
    } catch (error) {
      console.error("Error fetching MOQs:", error);
    }
  };
  

  if (isLoading) {
    return <Loader />;
  }

  return (

    <div className=" bg-white flex flex-row w-full justify-center overflow-y-hidden">

      {/* List of Customers Div start */}

      <div className=" flex flex-col  w-[32%]  ">

  <div className="p-4 border-b  flex flex-row justify-between ">

    <div>

    <h5 className="text-md font-semibold cursor-pointer ">All Item Groups

     <FontAwesomeIcon icon={faChevronDown} className="text-xs mb-0.5 text-blue-600 mx-1 cursor-pointer " />

    </h5>

    </div>

    <div className=''>

    <button 

  className="mr-2 bg-[#f7525a] text-white px-1 py-0.5 rounded-md" 

  title="" data-tooltip="Create Item Group" style={{ '--tooltip-bg': 'black' }}
  onClick={handleCreateItemGroup}>
  <FontAwesomeIcon icon={faPlus} className="mb-0.5 text-xs text-white mx-1 cursor-pointer" />

</button>

</div>

  </div>

  <div className=" flex justify-center  overflow-y-hidden  flex-col ">

   <div className='flex  flex-col h-[80vh]  overflow-y-auto '
    ref={listContainerRef}>

   {groupsToDisplay.map((productGroup) => (
  <div
    key={productGroup._id}
    ref={(el) => (itemRefs.current[productGroup._id] = el)}
    onClick={() => handleProductGroupClick(productGroup)}
    className={`border-b text-sm flex items-center px-4 py-2 ${selectedProductGroup?._id === productGroup._id ? 'bg-gray-100' : ''} hover:bg-gray-100 cursor-pointer`}
  >
    <div className='p-1 w-full flex flex-row justify-between'>
      <div className='w-[10%]'>
<input
  type="checkbox"
  className="mr-3 w-3 h-3 accent-blue-600 cursor-pointer"
/>      </div>
      <div className='w-[80%] flex flex-col pr-2'>
        <div>
          <p className='text-md font-semibold'>{productGroup.product_group_name}</p>
        </div>
        {productGroup?.UOM_id && (
          <div className='flex flex-row'>
            <p className='text-xs mr-1'>Units:</p>
            <p className='text-xs'>{productGroup.UOM_id.UOM}</p>
          </div>
        )}
      </div>
      <div className='w-[10%] flex flex-row'>
      {productGroup?.selling_price && (
        <p className='text-md font-semibold'>₹{productGroup.selling_price.toLocaleString()}</p>
      )}
      </div>
    </div>
  </div>
))}



  </div>

</div>

</div>

{/* List of Customers Div end */}

<div className="border-l  w-full flex flex-col ">
    {selectedProductGroup? (
  <>
  <div className="border-b h-24 over-flow-hidden"> {/* or h-12, depending on your desired height */}

<div className='p-4 flex justify-between  items-center relative'>
  <span className="text-md font-semibold">{selectedProductGroup.product_group_name}</span>
  <div className="flex items-center px-2 space-x-2">
     <button
        type="button"
        onClick={() =>  HandleMoqs()}
        className="px-3 py-1 bg-white text-blue-600 border border-blue-500 rounded-md text-sm flex items-center hover:bg-blue-50 transition-colors duration-200"
      >
        <FontAwesomeIcon icon={faPlusCircle} className="mr-2 text-blue-500" />
        MOQs
      </button>

      <button  onClick={handleNavigateEditItemGroup}  className="bg-gray-100 px-2 py-1 shadow-sm text-sm border rounded-md mr-2">
        Edit
      </button>
     {/*  <button className="bg-gray-100 px-1 py-1 shadow-sm text-sm border rounded-md mr-2">
        <FontAwesomeIcon icon={faPaperclip} className="text-md text-black mx-2 cursor-pointer " />
      </button>
      <button className="bg-[#f7525a] text-sm text-white px-2 py-1 shadow-sm border rounded-md mr-2">
        New Transaction
      </button> */}
     <div className="relative" ref={assignDropdownRef}>
  <button 
    className="bg-gray-100 text-sm px-2 py-1 shadow-sm border rounded-md mr-2"
    onClick={handleOpenAssign}
  >
    Assign
  </button>
  {assignType && (
    <div className="absolute right-0 mt-2 w-24 bg-white rounded-md shadow-lg z-10">
      <div 
        className="py-1 px-2 hover:bg-[#f7525a] hover:text-white cursor-pointer"
        onClick={() => handleAssignTypeSelect('attributes')}
      >
        Attributes
      </div>
      <div 
        className="py-1 px-2 hover:bg-[#f7525a] hover:text-white cursor-pointer"
        onClick={() => handleAssignTypeSelect('addons')}
      >
        Add-ons
      </div>
    </div>
  )}
</div>
      <button className=" text-white px-1 py-1 rounded-md "
        title="" data-tooltip="Close"  style={{ '--tooltip-bg': 'black' }}>   
        <FontAwesomeIcon icon={faX} onClick={handleClose} className="text-md text-[#f7525a] mx-2 cursor-pointer " />
      </button>
    </div>
</div>

</div>
{ProductGroupLoader ? (
    <Loader />
  ) : (
<div className="h-5/6 w-full flex justify-center text-[0.89rem]">
  <div className="flex flex-row h-full w-full">
    <div className="flex flex-1  flex-col">
     <div className="flex flex-col h-[80vh] overflow-y-auto bg-white">
  <div className="p-4 space-y-6">

    {/* ITEM GROUP ATTRIBUTES */}
    <section>
      <div className="flex items-center gap-3 mb-4">
        <h3 className="text-md text-[1rem] font-semibold">
          Item Group Attributes
        </h3>
      </div>

      {attributes.length > 0 ? (
        <div className="w-fit min-w-[280px] max-w-xl max-h-[200px] overflow-y-auto bg-white border border-gray-200 rounded-lg overflow-hidden shadow-sm">
          <div className="flex flex-col">
            {attributes.map((attribute, index) => (
              <div
                key={index}
                className={`grid grid-cols-[160px,minmax(0,1fr)] gap-4 px-5 py-2 ${
                  index !== attributes.length - 1
                    ? "border-b border-gray-100"
                    : ""
                }`}
              >
                <span className="text-sm text-gray-600">
                  {attribute.attribute_name}
                </span>

                <span className="text-sm font-medium text-gray-900 break-words">
                  {attribute.attribute_value}
                </span>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <div className="py-3 px-4 border border-dashed border-gray-200 rounded-xl bg-gray-50/30">
          <span className="text-xs text-gray-400 text-center">
            No attributes currently assigned to this group. Please assign attributes if needed.
          </span>
        </div>
      )}
    </section>


    {/* ITEM CATEGORY DETAILS */}
    <section>
      <div className="flex items-center gap-3 mb-4">
        <h3 className="text-md text-[1rem] font-semibold">
          Item Category Details
        </h3>
      </div>

      {productCategory ? (
        <div className="bg-white border border-gray-200 rounded-xl shadow-sm overflow-hidden">
          <div className="flex flex-col p-4 space-y-3">

            {/* Category Name */}
            <div className="grid grid-cols-[180px,minmax(0,1fr)] gap-4">
              <span className="text-sm text-gray-600">
                Item Category Name
              </span>

              <span className="text-sm font-semibold text-gray-900">
                {productCategory.category_name}
              </span>
            </div>

            {/* Description */}
            <div className="grid grid-cols-[180px,minmax(0,1fr)] gap-4 items-start">
              <span className="text-sm text-gray-600 mt-1">
                Description
              </span>

              <div className="border border-gray-200 rounded-lg px-3 py-2 bg-white">
                <p className="text-xs text-gray-600 break-words">
                  {productCategory?.category_description}
                </p>
              </div>
            </div>

          </div>
        </div>
      ) : (
        <div className="py-3 px-4 border border-dashed border-gray-200 rounded-xl bg-gray-50/30">
          <span className="text-xs text-gray-400">
            There are no Item Category currently assigned to this group.
          </span>
        </div>
      )}
    </section>


{(selectedProductGroup?.cost_price !== undefined ||
  selectedProductGroup?.selling_price !== undefined) && (

  <div className="grid grid-cols-1 md:grid-cols-2 gap-8">

    {/* PURCHASE INFORMATION */}
    {selectedProductGroup?.cost_price !== undefined && (
      <section className="flex flex-col">
        <div className="flex items-center gap-3 mb-4">
          <h3 className="text-md text-[1rem] font-semibold">
            Purchase Information
          </h3>
        </div>

        <div className="flex items-center justify-between p-5 bg-white border border-gray-200 rounded-2xl shadow-sm hover:shadow-md transition-shadow">
          <div className="flex items-center gap-4">
            <div className="w-8 h-8 bg-blue-50 text-blue-600 rounded-xl flex items-center justify-center text-lg">
              💳
            </div>

            <span className="text-sm text-gray-600">
              Cost Price
            </span>
          </div>

          <span className="text-lg font-black text-gray-900">
            ₹{selectedProductGroup?.cost_price?.toLocaleString()}
          </span>
        </div>
      </section>
    )}


    {/* SALES INFORMATION */}
    {selectedProductGroup?.selling_price !== undefined && (
      <section className="flex flex-col">
        <div className="flex items-center gap-3 mb-4">
          <h3 className="text-md text-[1rem] font-semibold">
            Sales Information
          </h3>
        </div>

        <div className="flex items-center justify-between p-5 bg-white border border-gray-200 rounded-2xl shadow-sm hover:shadow-md transition-shadow">
          <div className="flex items-center gap-4">
            <div className="w-8 h-8 bg-emerald-50 text-emerald-600 rounded-xl flex items-center justify-center text-lg">
              💰
            </div>

            <span className="text-sm text-gray-600">
              Selling Price
            </span>
          </div>

          <span className="text-lg font-black text-emerald-600">
            ₹{selectedProductGroup?.selling_price?.toLocaleString()}
          </span>
        </div>
      </section>
    )}

  </div>
)}


<section>
  <div className="flex items-center gap-3 mb-4">
    <h3 className="text-md text-[1rem] font-semibold">
      Vendor Details
    </h3>
  </div>

  {vendor ? (
    <div className="bg-white border border-gray-200 rounded-2xl p-6 shadow-sm hover:shadow-md transition-all">
      <div className="flex gap-5">

       <div className="w-14 h-14 rounded-xl flex-shrink-0 shadow-sm overflow-hidden border border-slate-100">
        {vendor.vendor_image ? (
          // Show vendor image if available
          <img
            src={`${imageUrl}${vendor.vendor_image}`}
            alt={`${vendor.vendor_name} avatar`}
            className="w-full h-full object-cover"
            onError={(e) => {
              // Fallback to initial avatar if image fails to load
              e.target.style.display = 'none';
              e.target.nextSibling.style.display = 'flex';
            }}
          />
        ) : null}
        
        <div 
          className={`w-full h-full bg-slate-50 border border-slate-100 text-slate-600 flex items-center justify-center font-bold text-xl flex-shrink-0 transition-all duration-200 ${
            vendor.vendor_image ? 'hidden' : 'flex'
          }`}
        >
          {vendor.vendor_name?.charAt(0)?.toUpperCase() || 'V'}
        </div>
      </div>

        {/* Right Side: Details */}
        <div className="flex-1 flex flex-col gap-2">

          {/* Vendor Name */}
          <div>
            <h4 className="text-md font-semibold leading-tight">
              {vendor.vendor_name}
            </h4>
          </div>

          {/* Company */}
          <div className="flex items-center gap-2">
            <span className="text-gray-400 text-sm">🏢</span>

            <span className="text-sm font-semibold text-blue-600 tracking-tight">
              {vendor.vendor_company}
            </span>
          </div>

          {/* Address */}
          {vendor.vendor_address && vendor.vendor_address.trim() !== "" && (
            <div className="flex items-start gap-2 border-t border-gray-50 pt-2">

              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="text-blue-500 mt-1"
              >
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                <circle cx="12" cy="10" r="3"></circle>
              </svg>

              <p className="text-sm leading-relaxed max-w-xs">
                {vendor.vendor_address}
              </p>

            </div>
          )}

          {/* Pincode */}
          {vendor.vendor_pincode && (
            <div className="flex items-center gap-2">

              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="text-red-500"
              >
                <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path>
                <line x1="7" y1="7" x2="7.01" y2="7"></line>
              </svg>

              <span className="text-sm font-medium">
                {vendor.vendor_pincode}
              </span>

            </div>
          )}

        </div>

      </div>
    </div>
  ) : (
    <div className="py-3 px-4 border border-dashed border-gray-200 rounded-xl bg-gray-50/30">
      <span className="text-xs text-gray-400 italic">
        There are no vendors currently assigned to this group.
      </span>
    </div>
  )}
</section>

  </div>
</div>
    </div>

    <div className="flex w-60 h-full p-2 justify-center">
  <div 
    className="cursor-pointer flex flex-col h-48 justify-center mt-4 p-2 w-40 border border-dashed border-gray-300 rounded-lg transition-colors"
    onDragOver={handleDragOver}
    onDragLeave={handleDragLeave}
    onDrop={handleDrop}
     onClick={handleFileInputClick}
  >
   <div className="flex justify-center">
  {selectedProductGroup?.product_group_image ? (
    <img
      src={imageUrl + selectedProductGroup.product_group_image}
      alt={selectedProductGroup.product_group_name}
      className="flex w-28 h-28 object-cover rounded-lg"
    />
  ) : (
    <div className="flex w-28 h-28 bg-gray-100 rounded-lg items-center justify-center">
    <div className="flex w-28 h-28 bg-gray-100 rounded-lg items-center justify-center">
              <FontAwesomeIcon 
                icon={faImage} 
                className="text-gray-400 text-3xl" 
              />
            </div>
    </div>
  )}
</div>
    <div className=" flex justify-between mt-4">
       <input
      type="file"
      id="imageInput"
      style={{ display: 'none' }}
      accept="image/*"
      onChange={handleImageChange}
    />
    <div className="text-center text-xs text-gray-400">
      Click or drag to upload
    </div>
      <FaRegTrashAlt 
        className="text-xs text-gray-600 mx-1 cursor-pointer" 
         onClick={(e) => {
          e.stopPropagation(); 
           handleDeleteItemGroupImage(selectedProductGroup)
         }}
      />
    </div>
   
  </div>
  {isUploading && <p>Uploading...</p>}
</div>

  </div>
</div>
 )}
  </>
    ):(
 <div className="flex justify-center items-center h-full">
    <p className="text-gray-500">Select a Item Group to view details</p>

</div>
    )}



</div>

{showPopup && (
  <div>
    {popupType === '200or201' && <Msg200or201 message={popupMessage} timeout={3000} />}
    {popupType === '204' && <Msg204 message={popupMessage} timeout={3000} />}
    {popupType === '400' && <Msg400 message={popupMessage} closePopup={closePopup} />}
          {popupType === '401' && <Msg401 message={popupMessage} closePopup={BackToLoginPage} />}
          {popupType === '403' && <Msg403 message={popupMessage} closePopup={BackToLoginPage} />}
          {popupType === '500' && <Msg500 message={popupMessage} closePopup={Retry} cancelPopup={closePopup} />}
  </div>
)}

{showAssignAttributesPopup && (
  <div className="fixed z-20 inset-0 flex items-top justify-center bg-gray-800 bg-opacity-50">
<div className="bg-white rounded-b-md shadow-md w-1/2 h-[70vh] flex flex-col">
      <div className='bg-[#F9F9FB] flex justify-between items-center w-full h-[10%] px-6'>
        <h2 className="text-md">{assignType === 'attributes' ? 'Attributes' : 'Add-ons'}</h2>
        <button onClick={handleCloseAttributePopup} className="text-white px-1 py-1 rounded-md ">   
          <FontAwesomeIcon icon={faX} className="text-xs text-[#e54643] cursor-pointer " />
        </button>
      </div>
      <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
      {attributeLoading ? (
        <Loader />
      ) : (
        assignType === 'attributes' ? (
          <>
           <div className="flex-1 overflow-y-auto w-full flex flex-col items-center px-6 py-4 space-y-4">   
             {Object.keys(errors).length > 0 && (
                <div className="flex justify-between w-full p-2 items-center px-auto py-3 bg-[#fddcde] rounded-md">
                  <div className="px-6 flex flex-col space-y-2 justify-start items-start">
                    {errors.assign_attribute && (
                      <span className="text-sm">• {errors.assign_attribute}</span>
                    )}
                  </div>
                  <div className='px-4'>
                    <button
                      className="text-gray-700 hover:text-red-500"
                      onClick={() => setErrors({})}
                    >
                      <FontAwesomeIcon icon={faX} className="text-xs text-[#F7525A] cursor-pointer" />
                    </button>
                  </div>
                </div>
              )}
              <div className="flex justify-center flex-col items-center">
                {productAttributes.length > 0 ? (
                <table>
                  <tbody>
                    {productAttributes.map((attribute, index) => (
                      <tr key={index} className='border-2 border-opacity-50'>
                        <td className='py-2 px-4 border-2 border-opacity-50'>
                          <h1 className='font-semibold'>{attribute.attribute_name}</h1>
                        </td>
                        <td>
                          <div className='flex flex-col text-sm items-left ml-10 px-4 py-2'>
                            {attribute.attribute_values.map((attributeValue, attributeValueIndex) => (
  <div key={`${attribute.attribute_name_id}_${attributeValue.attribute_value_id}`} className='flex flex-row items-center'>
                                <input
                                  type='checkbox'
      id={`attribute_${attribute.attribute_name_id}_${attributeValue.attribute_value_id}`}  // ✅ STABLE ID
                                  // name={`attribute_${index}`}
                                  onChange={() => handleCheckboxChange(attribute.attribute_name_id, attributeValue.attribute_value_id)}
      checked={attributeIds.some(id => id.attribute_value_id === attributeValue.attribute_value_id)}
      className="w-4 h-4 border-gray-400 accent-red-600 cursor-pointer"
    />
    <label htmlFor={`attribute_${attribute.attribute_name_id}_${attributeValue.attribute_value_id}`} className='ml-5'>
      {attributeValue.attribute_value}
    </label>
  </div>
))}
                             
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                 ) : (

    <div className="flex justify-center items-center h-64 w-full">
      <span className="text-gray-500 text-sm">
        No attributes available.
      </span>
    </div>

  )}

              </div>
            </div>
            <div className="mt-auto w-full">
              <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
              <div className="flex justify-start items-end space-x-2 px-6 mt-5 mb-4">
                <button 
                  className="px-2 py-1 bg-[#f7525a] border-[#f7525a] text-white rounded-md space-x-2 flex items-center"
                  onClick={handleAddattributesToGroup}
                >
                  <span>Save</span>
                  {isSaving && (<Spinner/>)}
                </button>
                <button 
                  onClick={handleCloseAttributePopup}  
                  className={`hover:border-[#DDDDDD] focus:border-[#DDDDDD] focus:ring focus:ring-[#DDDDDD] focus:ring-opacity-50 px-2 py-1 rounded-md ${
                    isSaving ? 'bg-gray-400 text-gray-500 cursor-not-allowed' : 'bg-[#f5f5f5] text-gray-700 border border-[#DDDDDD]'
                  }`}
                  disabled={isSaving}
                >
                  Cancel
                </button>
              </div>
            </div>
          </>
        ) : (
          <div className="flex flex-col h-full">
            <div className="grid grid-cols-3 gap-3 pl-2 py-2 flex-grow overflow-y-auto">
              {AddOnsProductGroups.length > 0 ? (
                AddOnsProductGroups.map((group) => (
                  <div key={group._id} className="flex p-2 flex-row justify-center space-x-2">
                    <input
                      type="checkbox"
                      id={group._id}
                      value={group._id}
                      className="form-checkbox h-4 w-4 text-[#EB001B] focus:ring-[#EB001B]"
                      checked={selectedAddOns.includes(group._id)}
                      onChange={() => handleAddOnChange(group._id)}
                    />
                    <label htmlFor={group._id} className="text-gray-700">{group.product_group_name}</label>
                  </div>
                ))
              ) : (
                <div className="col-span-3 flex justify-center items-center h-full">
                <span className="text-gray-500 text-sm">
                 No add-on product groups available.
                </span>
               </div>
              )}
            </div>
            <div className="mt-auto w-full">
              <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
              <div className="flex justify-start items-end space-x-2 px-6 mt-5 mb-4">
                <button 
                  className="px-2 py-1 bg-[#f7525a] border-[#f7525a] text-white rounded-md space-x-2 flex items-center"
                  onClick={handleAssignAddOnGroupsToMainGroups}
                >
                  <span>Save</span>
                  {isSaving && (<Spinner/>)}
                </button>
                <button 
                  onClick={handleCloseAttributePopup}  
                  className={`hover:border-[#DDDDDD] focus:border-[#DDDDDD] focus:ring focus:ring-[#DDDDDD] focus:ring-opacity-50 px-2 py-1 rounded-md ${
                    isSaving ? 'bg-gray-400 text-gray-500 cursor-not-allowed' : 'bg-[#f5f5f5] text-gray-700 border border-[#DDDDDD]'
                  }`}
                  disabled={isSaving}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )
      )}
    </div>
  </div>
)}

  {showQuantityPricingPopup && (
  <div className="fixed inset-0 z-50 flex items-top justify-center bg-gray-800 bg-opacity-50">
    <div className="bg-white rounded-b-md shadow-md w-3/4 h-3/4 flex flex-col animate-slide-in">
      <div className='bg-[#F9F9FB] flex justify-between items-center w-full h-[10%] px-6'>
        <h2 className="text-md font-semibold">Quantity-based Pricing</h2>
        <button onClick={() => setShowQuantityPricingPopup(false)} className="text-white px-1 py-1 rounded-md">   
          <FontAwesomeIcon icon={faX} className="text-xs text-[#e54643] cursor-pointer" />
        </button>
      </div>
      <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
      
      <div className="flex-grow overflow-auto p-6">
        <table className="w-full border-collapse">
          <thead>
            <tr className="text-[#6c7184] bg-[#fafafc]">
              <th className="font-semibold text-left text-sm py-2 px-4 border">Min Quantity</th>
              <th className="font-semibold text-left text-sm py-2 px-4 border">Max Quantity</th>
              <th className="font-semibold text-left text-sm py-2 px-4 border">Selling Price</th>
              <th className="font-semibold text-left text-sm py-2 px-4 border">Cost Price</th>
              <th className="font-semibold text-left text-sm py-2 px-4 border">Actions</th>
            </tr>
          </thead>
          <tbody>
            {quantityPricingRows.map((row, index) => (
              <tr key={index}>
                <td className="border p-2">
                  <input
                    type="number"
                    value={row.minQuantity}
                    onChange={(e) => handleQuantityPricingChange(index, 'minQuantity', e.target.value)}
                    className="outline-blue-500 text-sm w-full p-2 bg-transparent rounded-md hover:border-blue-500 hover:ring-1 hover:ring-blue-500 hover:ring-opacity-90"
                    placeholder="Min"
                  />
                </td>
                <td className="border p-2">
                  <input
                    type="number"
                    value={row.maxQuantity}
                    onChange={(e) => handleQuantityPricingChange(index, 'maxQuantity', e.target.value)}
                    className="outline-blue-500 text-sm w-full p-2 bg-transparent rounded-md hover:border-blue-500 hover:ring-1 hover:ring-blue-500 hover:ring-opacity-90"
                    placeholder="Max"
                  />
                </td>
                <td className="border p-2">
                  <input
                    type="number"
                    value={row.sellingPrice}
                    onChange={(e) => handleQuantityPricingChange(index, 'sellingPrice', e.target.value)}
                    className="outline-blue-500 text-sm w-full p-2 bg-transparent rounded-md hover:border-blue-500 hover:ring-1 hover:ring-blue-500 hover:ring-opacity-90"
                    placeholder="Selling Price"
                  />
                </td>
                <td className="border p-2">
                  <input
                    type="number"
                    value={row.costPrice}
                    onChange={(e) => handleQuantityPricingChange(index, 'costPrice', e.target.value)}
                    className="outline-blue-500 text-sm w-full p-2 bg-transparent rounded-md hover:border-blue-500 hover:ring-1 hover:ring-blue-500 hover:ring-opacity-90"
                    placeholder="Cost Price"
                  />
                </td>
                <td className="border p-2">
                  {quantityPricingRows.length > 1 && (
                    <button
                      type="button"
                      onClick={() => deleteQuantityPricingRow(index)}
                      className="text-red-500 hover:text-red-700"
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        
        <div className="mt-4">
          <button
            onClick={addQuantityPricingRow}
            className="text-blue-500 py-2 px-4 hover:text-blue-700"
          >
            <FontAwesomeIcon icon={faPlusCircle} className="mr-2" />
            Add Row
          </button>
        </div>
      </div>
      
      <div className="mt-auto w-full">
        <hr className="border-t border-gray-200 w-full" style={{ borderTopWidth: '1px' }} />
        <div className="flex justify-start items-end space-x-2 px-6 mt-5 mb-4">
          <button 
            className="px-2 py-1 bg-[#f7525a] border-[#f7525a] text-white rounded-md"
            onClick={saveQuantityPricing}
          >
            Save
          </button>
          <button 
            onClick={() => setShowQuantityPricingPopup(false)} 
            className="px-2 py-1 bg-[#f5f5f5] text-gray-700 border border-[#DDDDDD] rounded-md"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
)}
               
    </div>

  );

};



export default ViewProductGroup;